import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"
import { formatNumberInputWithSpaceAfter5Numbers } from "@/utils"
import '@/pages/profile/sections/common.css'
import { useEffect, useState } from 'react';

import moment from "moment";
import "./style.css";

export default function AllInfoPage(props: any) {
    const { common, profile, timeline } = useLocalTranslation();
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);

    const [uiToRenderList, setUiToRenderList] = useState<string[]>([]);

    useEffect(() => {
        handleWhichUiToRender()
    }, [profileDetails]);


    const handleWhichUiToRender = () => {
        setUiToRenderList(prevList => {
            if (!prevList.includes(timeline.verifySection.basicDetails) && showBasicDetails()) {
                return [...prevList, timeline.verifySection.basicDetails];
            }
            return prevList;
        });


        setUiToRenderList(prevList => {
            if (!prevList.includes(timeline.verifySection.legalInformation) && showLegalInfo()) {
                return [...prevList, timeline.verifySection.legalInformation];
            }
            return prevList;
        });


        setUiToRenderList(prevList => {
            if (!prevList.includes(timeline.verifySection.deliveryAddress) && showDeliveryAddress()) {
                return [...prevList, timeline.verifySection.deliveryAddress];
            }
            return prevList;
        });


        setUiToRenderList(prevList => {
            if (!prevList.includes(timeline.verifySection.verification) && showVerification()) {
                return [...prevList, timeline.verifySection.verification];
            }
            return prevList;
        });

    }


    const showBasicDetails = () => {
        let show = false;
        if (profileDetails
            && profileDetails.displayName
            && profileDetails.username
            && profileDetails.email
            && profileDetails.dob
            && profileDetails.whatsAppNumber
            && profileDetails.whatsAppCountryCode) {
            show = true
        }
        return show;
    }

    const showLegalInfo = () => {
        let show = false;
        if (profileDetails
            && profileDetails.firstName
            && profileDetails.middleName
            && profileDetails.lastName) {
            show = true
        }
        return show;
    }

    const showDeliveryAddress = () => {
        let show = false;
        if (profileDetails
            && profileDetails.flatHouseNumber
            && profileDetails.buildingName
            && profileDetails.colonyName
            && profileDetails.areaName
            && profileDetails.landmark
            && profileDetails.country
            && profileDetails.pincode
            && profileDetails.state
            && profileDetails.city
        ) {
            show = true
        }
        return show;
    }


    const showVerification = () => {
        let show = false
        if (profileDetails.isUnderGraduate != null) {
            if (profileDetails.isUnderGraduate === false
                && profileDetails.qualificationNote
                && profileDetails.lookingForNote
            ) {
                show = true
            } else if (profileDetails.isUnderGraduate === true) {

            }
        }


        if (profileDetails
            && profileDetails.flatHouseNumber
        ) {
            show = true
        }
        return show
    }

    return (
        <div className='allInfoPageMain profileSectionOfSectionCommonMainCon'>
            {uiToRenderList.includes(timeline.verifySection.basicDetails) &&
                <div>
                    <p className='commonH2'>
                        {timeline.verifySection.basicDetails}
                    </p>
                    <div className='allInfoPageMain_con1'>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.displayName}
                            </p>
                            <p className='a1 truncate max-w-full'>
                                {profileDetails.displayName}
                            </p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.username}
                            </p>
                            <p className='a1 truncate max-w-full'>
                                {profileDetails.username}
                            </p>
                        </div>
                        <hr />
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.email}
                            </p>
                            <p className='a1 truncate max-w-full'>
                                {profileDetails.email}
                            </p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>{profile.fields.dateOfBirth}</p>
                            <p className='a1 truncate max-w-full'>
                                {moment(profileDetails.dob).format("MM/DD/YYYY")}
                            </p>
                        </div>
                        <div className='flex'>
                            <p className='p1_last'>
                                {profile.fields.whatsAppNumber}
                            </p>
                            <p className='a1 truncate max-w-full'>
                                {profileDetails.whatsAppCountryCode} {' '}{formatNumberInputWithSpaceAfter5Numbers(profileDetails.whatsAppNumber)}
                            </p>
                        </div>
                    </div>
                </div>
            }



            {uiToRenderList.includes(timeline.verifySection.legalInformation) &&
                <div>
                    <p className='commonH2 mt-[10px]'>
                        {timeline.verifySection.legalInformation}
                    </p>
                    <div className='allInfoPageMain_con1'>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.legalFirstName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.firstName}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.legalMiddleName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.middleName}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1_last'>
                                {profile.fields.legalLastName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.lastName}</p>
                        </div>
                    </div>
                </div>
            }



            {uiToRenderList.includes(timeline.verifySection.deliveryAddress) &&
                <div>
                    <p className='commonH2 mt-[10px]'>
                        {timeline.verifySection.deliveryAddress}
                    </p>
                    <div className='allInfoPageMain_con1'>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.flatHouseNumber}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.flatHouseNumber}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>{
                                profile.fields.buildingName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.buildingName}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.colonyName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.colonyName}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.areaName}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.areaName}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.landmark}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.landmark}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.country}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.country}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.pincode}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.pincode}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1'>
                                {profile.fields.state}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.state}</p>
                        </div>
                        <div className='flex'>
                            <p className='p1_last'>
                                {profile.fields.city}
                            </p>
                            <p className='a1 truncate max-w-full'>{profileDetails.city}</p>
                        </div>
                    </div>
                </div>
            }


            {uiToRenderList.includes(timeline.verifySection.verification) &&
                <div>
                    <p className='commonH2 mt-[10px]'>
                        {profile.identityVerificationSection.heading}
                    </p>

                    {profileDetails.isUnderGraduate === true ?
                        (
                            <div className='allInfoPageMain_con1'>

                                <div>
                                    <p className='p2'>
                                        {profile.fields.haveYouinishedYourUndergraduateDegree}
                                    </p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.isUnderGraduate ? "Yes" : "No"}</p>
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>

                                <div>
                                    <p className='p2'>
                                        {profile.fields.selectUndergraduateDegree}
                                    </p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.underGraduateDegree}</p>
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>

                                <div>
                                    <p className='p2'>
                                        {profile.fields.marksheetOrDegreeCertificate}
                                    </p>
                                    <img
                                        className='marksheetOrDegreeCert'
                                        src={profileDetails.marksheetOrDegreeCert} alt="marksheetOrDegreeCert" />
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>

                                <div>
                                    <p className='p2'>{profile.fields.nameAsOnMarksheetDegreeCertificate}</p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.fullName}</p>
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>


                                <div>
                                    <p className='p2'>{profile.fields.iDProof}</p>
                                    <img
                                        className='aadharOrIdProof'
                                        src={profileDetails.aadharOrIdProof} alt="aadharOrIdProof" />
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>

                                <div>
                                    <p className='p2'>{profile.fields.legalPhoto}</p>
                                    <img
                                        className='passportPhoto'
                                        src={profileDetails.passportPhoto} alt="passportPhoto" />
                                </div>


                            </div>
                        ) : (
                            <div className='allInfoPageMain_con1'>
                                <div>
                                    <p className='p2'>{profile.fields.haveYouinishedYourUndergraduateDegree}</p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.isUnderGraduate ? "Yes" : "No"}</p>
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>

                                <div>
                                    <p className='p2'>{profile.fields.qualificationNote}</p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.qualificationNote}</p>
                                    <hr
                                        className='mt-[15px] mb-[10px]'
                                    />
                                </div>


                                <div>
                                    <p className='p2'>{profile.fields.whatAreYouLookingFor2}</p>
                                    <p className='a1 truncate max-w-full'>{profileDetails.lookingForNote}</p>
                                </div>
                            </div>
                        )}
                </div>
            }

            <div className='commonBtnCon1'>
                <button
                    disabled={props.isSubmitBtnLoading}
                    style={{
                        cursor: props.isSubmitBtnLoading ? 'not-allowed' : 'pointer',
                        backgroundColor: props.isSubmitBtnLoading ? '#9f9f9f' : '#1573FE'
                    }}
                    onClick={() => props.handleSubmit(listOfSections.allInfoPage)}
                    className='w-[100%] text-white rounded-[5px] py-[8px] text-[14px] font-medium mt-[13px]'>
                    {common.statusText.submitBtn}
                </button>

                {/* <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.fullName)}
                /> */}
            </div>
        </div>
    );
}
